import React, { useState } from 'react';
import axios from 'axios';
import BoardList from '../../components/Board/BoardList';
import BoardWrite from '../../components/Board/BoardWrite';
import BoardDetail from '../../components/Board/BoardDetail';
import Breadcrumb from '../../components/common/Breadcrumb';

const QuoteRequest = () => {
  const [mode, setMode] = useState('list');
  const [selectedPost, setSelectedPost] = useState(null);

  const handleSubmit = async (form) => {
    try {
      const productName = form.products.join(', ');
      const title = `${form.products[0] || '제품'} 견적 요청`;
      const content = `제품: ${productName}\n수량: ${form.quantity || '-'}\n사용용도: ${form.use_purpose || '-'}`;

      await axios.post('/api/user/requests/write', {
        type: 'quote',
        title,
        content,
        use_purpose: form.use_purpose,
        product_id: null,
        product_name: productName,
        company_name: form.company_name,
        author_name: form.author_name,
        author_phone: form.author_phone,
        author_email: form.author_email || null,
        quantity: form.quantity,
        password: form.password,
        is_private: 1,
      });

      alert('견적 요청이 정상적으로 등록되었습니다.');
      setMode('list');
    } catch (err) {
      console.error(err);
      alert(err?.response?.data?.message || '등록에 실패했습니다.');
    }
  };

  return (
    <div className="sub-page quote-request">
      <section className="sub-visual quite">
        <div className="container">
          <span className="sub-title">QUOTE REQUEST</span>
          <h1>견적요청</h1>
          <p>필요하신 제품의 사양을 남겨주시면 최적의 단가와 일정을 제안해 드립니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <div className="container content-wrap">
        {mode === 'list' && (
          <BoardList
            type="quote"
            title="견적요청 게시판"
            onWrite={() => setMode('write')}
            onDetail={(item) => {
              setSelectedPost(item);
              setMode('detail');
            }}
          />
        )}

        {mode === 'write' && <BoardWrite type="quote" onCancel={() => setMode('list')} onSubmit={handleSubmit} />}

        {mode === 'detail' && selectedPost && (
          <BoardDetail
            post={selectedPost}
            allPosts={[]}
            onBack={() => {
              setSelectedPost(null);
              setMode('list');
            }}
            onChangePost={() => {}}
          />
        )}
      </div>
    </div>
  );
};

export default QuoteRequest;
